"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.ColdArticleEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../../types");
var constants_1 = require("../../../constants");
var field_groups_1 = require("../../../field-groups");
var fields_1 = require("../../../fields");
var slices_1 = require("../../../slices");
var page_factory_1 = require("./page-factory");
exports.ColdArticleEntity = page_factory_1.pageFactory(types_1.PageType.COLD_ARTICLE, function (prismicDoc, normalizedPage, logger) {
    var _a;
    var _b, _c, _d, _e, _f, _g;
    return utils_1.compact(__assign(__assign({}, normalizedPage), { banner: field_groups_1.toBanner(utils_1.unprefix('header', prismicDoc.data), logger), localization: logger.required(constants_1.toLocalization((_b = prismicDoc.data) === null || _b === void 0 ? void 0 : _b.localization, logger)), filters: utils_1.compact((_a = {},
            _a[types_1.Filter.Localization] = constants_1.toLocalizationFilter((_c = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _c === void 0 ? void 0 : _c.localization, logger),
            _a[types_1.Filter.Thematic] = constants_1.toThematic((_d = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _d === void 0 ? void 0 : _d.thematic, logger),
            _a)), body: slices_1.toSlices((_e = prismicDoc.data) === null || _e === void 0 ? void 0 : _e.body_slices, logger), card: {
            title: fields_1.toText((_f = prismicDoc.data) === null || _f === void 0 ? void 0 : _f.card_title),
            image: fields_1.toImage((_g = prismicDoc.data) === null || _g === void 0 ? void 0 : _g.card_image, logger)
        } }));
});
//# sourceMappingURL=cold-article.js.map